import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import {AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend} from 'recharts'

class TimeCountGraph extends React.Component {
	constructor(props) {
		super(props);
	}

	getDataKey(data) {
  	let k = Object.keys(data[0]);
  	let v = k.filter(function(s) {
  		return s !== "time"
  	})
  	return v[0];
	}

  render() {
  	const {data} = this.props;

  	let dataKey = this.getDataKey(data);

    return (
			<AreaChart width={1200} height={300} data={data}>
				<XAxis dataKey="time"/>
				<YAxis/>
				<CartesianGrid strokeDasharray="3 3"/>
				<Tooltip/>
				<Legend />
				<Area type='monotone' dataKey={dataKey} stroke='#8884d8' fill='#8884d8' />
      </AreaChart>
    )
  }
}

export default TimeCountGraph;


// WEBPACK FOOTER //
// ./app/javascript/components/TimeCountGraph.jsx